import { render, staticRenderFns } from "./LoaderLayout.vue?vue&type=template&id=4ff07610&"
import script from "./LoaderLayout.vue?vue&type=script&lang=js&"
export * from "./LoaderLayout.vue?vue&type=script&lang=js&"
import style0 from "./LoaderLayout.vue?vue&type=style&index=0&id=4ff07610&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports